import React, { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { useParams } from 'react-router-dom';
import { Modal } from 'semantic-ui-react';
import { Common } from '../../../components';
import { RouteParams } from '../../../types/routeParams';
import { useAppDispatch } from '../../../hooks';
import { ITerminal } from '../../../models/Terminal';
import { RootState } from '../../../store';
import {
  defaultTerminalListSearch,
  deleteTerminal
} from '../store/terminalActions';
import { assignedFilter, unassignedFilter } from '../store/terminalReducer';

interface IDeleteDeviceProps {
  terminal: ITerminal;
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
}

export const DeleteDevice = ({
  terminal,
  isOpen,
  setIsOpen
}: IDeleteDeviceProps) => {
  // hooks
  const dispatch = useAppDispatch();
  const terminalReducer = useSelector((state: RootState) => state.terminal);
  const { tab } = useParams<RouteParams>();
  // states
  const [isLoading, setIsLoading] = useState(false);
  // defaults
  const isAssignedTab = tab === 'assigned';

  const onDeleteClick = () => {
    setIsLoading(true);
    if (terminal.id) {
      dispatch(deleteTerminal(terminal.id));
    } else {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (
      isOpen &&
      isLoading &&
      (terminalReducer.record?.success?.show || terminalReducer.record?.error)
    ) {
      setTimeout(() => {
        const filter = isAssignedTab ? assignedFilter : unassignedFilter;
        setIsLoading(false);
        setIsOpen(false);
        dispatch(defaultTerminalListSearch(filter));
      }, 100);
    }
  }, [terminalReducer, terminalReducer.record.error]);

  return (
    <Modal open={isOpen} size="tiny">
      <Modal.Content>
        <h3 className="modal-title">
          <Translate value="terminal.delete-modal.title" />
        </h3>
        <p className="modal-description">
          <Translate value={`terminal.delete-modal.description`} />
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Common.Button
          disabled={isLoading}
          onClick={() => setIsOpen(false)}
          content={<Translate value="terminal.delete-modal.cancel" />}
        />
        <Common.Button
          negative
          loading={isLoading}
          content={<Translate value="terminal.delete-modal.delete" />}
          onClick={onDeleteClick}
        />
      </Modal.Actions>
    </Modal>
  );
};
